import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  light?: boolean;
}

export default function Breadcrumb({ items, light = false }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.label,
      item: item.to || 'https://heraultroulettesbaiesvitrees.fr/',
    })),
  };

  const linkClass = light
    ? 'text-[#DCE8F2] hover:text-white transition-colors duration-200'
    : 'text-secondary-500 hover:text-accent-500 transition-colors duration-200';

  const sepClass = light ? 'text-[#7FA3C2]' : 'text-secondary-400';

  const lastClass = light
    ? 'text-white font-semibold'
    : 'text-foreground-500 font-semibold';

  const midClass = light ? 'text-[#DCE8F2]' : 'text-secondary-500';

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="Fil d'Ariane" className="py-3">
        <ol className="flex items-center flex-wrap gap-1 text-sm font-body">
          {items.map((item, i) => (
            <li key={i} className="flex items-center gap-1">
              {i > 0 && (
                <span className={`${sepClass} mx-1`}>
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-s-line text-xs"></i>
                  </span>
                </span>
              )}
              {item.to && i < items.length - 1 ? (
                <Link to={item.to} className={linkClass}>
                  {item.label}
                </Link>
              ) : (
                <span className={i === items.length - 1 ? lastClass : midClass}>
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}